import React, {Fragment} from "react";
import InputKpiController from "./InputKpiController";
import {
    TIPO_ELEMENTO_BTN_AGGIUNGI,
    TIPO_ELEMENTO_LISTA, TIPO_ELEMENTO_NOTA,
    TIPO_ELEMENTO_VALORE
} from "../../../../utility/common";
import {Form, Formik} from "formik";
import {Dialog} from 'primereact/dialog';
import NsFormikScrollToError from "../../../../components/NsFormikScrollToError";
import InputKpiEsrsController from "./InputKpiEsrsController";
import ModalMsg from "../../../../components/ModalMsg";

export default function TabellaKpiView({
                                           tabella,
                                           elementoDettagli,
                                           showDettagli,
                                           formikRef,
                                           getIconaDettaglio,
                                           getClasse,
                                           modifica,
                                           handlerChange,
                                           getClasseAllineamentoEl,
                                           getValoreByTipo,
                                           onHideDialog,
                                           getValoreTopics,
                                           getDescrTopics,
                                           idUtenteLoggato,
                                           aggiungiRiga,
                                           modalMsg,
                                           showMsg,
                                           setShowMsg,
                                       }) {

    function disegnaValoreElemento(el) {
        if (el.topics_valori && el.topics_valori.length > 0) {
            /*
             * =================================
             * ===== Gestione ESRS
             * =================================
             */
            return (
                <div
                    className={"sost-cella-val-kpi text-start"}>
                    <ul>
                        {
                            JSON.parse(JSON.stringify(el.topics_valori))
                                .reduce((acc, curr) => {
                                    const {id_topic, value} = curr;
                                    if (acc[id_topic]) {
                                        acc[id_topic].value += '; ' + value;
                                    } else {
                                        acc[id_topic] = curr;
                                    }
                                    return acc;
                                }, [])
                                .map((valTopic) => (
                                    <li key={valTopic.id_topic}>
                                        <strong>{valTopic.descr_topic}:&nbsp;</strong>
                                        {valTopic.value}
                                    </li>
                                ))
                        }
                    </ul>
                </div>
            );
        } else {
            return (
                <div
                    className={"sost-cella-val-kpi " + getClasseAllineamentoEl(el)}>
                    {getValoreByTipo(el)}
                    {getIconaDettaglio(el)}
                </div>
            );
        }
    }

    function disegnaElemento(modifica, el, idxLivello, idxSottolivello, idxElemento, errors, values, submitCount) {
        if (parseInt(el.tipo) === TIPO_ELEMENTO_BTN_AGGIUNGI) {
            return (
                <div className={"w-100 text-center"}>
                    <i
                        className="fas fa-plus-circle ns-mouse-pointer"
                        style={{fontSize: '1.8rem'}}
                        onClick={() => {
                            if (modifica) {
                                aggiungiRiga(el)
                            }
                        }}
                    ></i>
                </div>
            );
        } else if (modifica) {
            if ((parseInt(el.tipo) === TIPO_ELEMENTO_VALORE
                || parseInt(el.tipo) === TIPO_ELEMENTO_LISTA
                || parseInt(el.tipo) === TIPO_ELEMENTO_NOTA)) {
                if (el.topics && el.topics.length > 0) {
                    /*
                     * =================================
                     * ===== Gestione ESRS
                     * =================================
                     */
                    return el.topics.map(tv => {
                        let topicVal = (el.topics_valori
                            && JSON.parse(JSON.stringify(el.topics_valori))
                                .reduce((acc, curr) => {
                                    const {id_topic, value} = curr;
                                    if (acc[id_topic]) {
                                        acc[id_topic].value += '; ' + value;
                                    } else {
                                        acc[id_topic] = curr;
                                    }
                                    return acc;
                                }, [])
                                .filter(val => val.id_topic == tv.id_topic)[0]?.value) || '';
                        return (
                            <div 
                            className={"mt-2 " + (errors[el.cella + '_' + tv.id_topic] && submitCount > 0 ? ' sost-esrs-obbligatorio' : '')} 
                            key={tv.id_topic}>
                                <label
                                    className="form-label">{tv.descrizione}:</label>
                                <InputKpiEsrsController
                                    tabella={tabella}
                                    idxLivello={idxLivello}
                                    idxSottolivello={idxSottolivello}
                                    idxElemento={idxElemento}
                                    handlerChange={handlerChange}
                                    disabled={!modifica}
                                    modifica={modifica}
                                    formikRef={formikRef}
                                    errors={errors}
                                    values={values}
                                    valEsrs={topicVal}
                                    topic={tv}
                                    idUtenteLoggato={idUtenteLoggato}
                                />
                            </div>
                        );
                    });
                } else {
                    return (
                        <InputKpiController
                            tabella={tabella}
                            idxLivello={idxLivello}
                            idxSottolivello={idxSottolivello}
                            idxElemento={idxElemento}
                            handlerChange={handlerChange}
                            disabled={!modifica}
                            modifica={modifica}
                            formikRef={formikRef}
                            errors={errors}
                            values={values}
                        />
                    );
                }
            } else {
                return disegnaValoreElemento(el);
            }
        } else {
            return disegnaValoreElemento(el);
        }
    }

    return (
        <Fragment>
            <ModalMsg
                show={showMsg}
                handleClose={() => setShowMsg(false)}
                testo={modalMsg}/>
            <Dialog
                header={elementoDettagli ? (elementoDettagli.titolo_dettaglio || '') : ''}
                visible={showDettagli}
                style={{width: '50vw'}}
                onHide={onHideDialog}
            >
                <div className="mn-2">
                    {
                        elementoDettagli && elementoDettagli.testo_dettaglio && typeof elementoDettagli.testo_dettaglio != 'undefined' &&
                        elementoDettagli.testo_dettaglio.split('\n').map((paragraph, index) =>
                            <p key={index}>{paragraph}</p>
                        )
                    }
                </div>
            </Dialog>
            <Formik
                initialValues={{}}
                innerRef={formikRef}
                onSubmit={values => {
                    // TODO
                }}
            >
                {({errors, touched, submitCount, values}) => (
                    <Form className="row g-3 sost-tabella-kpi-container">
                        {
                            tabella && tabella.map((livello, idxLivello) =>
                                <Fragment key={idxLivello}>
                                    <table className={"sost-tabella-livello-kpi"}>
                                        <tbody>
                                        {
                                            livello.titolo && livello.titolo !== '' &&
                                            <tr className={"sost-tr-titolo-livello-kpi"}>
                                                <td
                                                    className={"sost-td-titolo-livello-kpi"}
                                                    colSpan={livello.colspan}
                                                    rowSpan={livello.rowspan}
                                                >{livello.titolo} {getIconaDettaglio(livello)}</td>
                                            </tr>
                                        }
                                        {
                                            livello.sottolivelli && livello.sottolivelli.map((sottolivello, idxSottolivello) =>
                                                <tr className={"sost-tr-titolo-sottolivello"} key={idxSottolivello}>
                                                    {
                                                        sottolivello.elementi && sottolivello.elementi
                                                            .filter((el) => parseInt(el.tipo) != TIPO_ELEMENTO_BTN_AGGIUNGI)
                                                            .map((el, idxElemento) =>
                                                            <td
                                                                key={idxElemento}
                                                                className={"sost-td-elemento-kpi "
                                                                    + getClasse(el, errors, submitCount)
                                                                }
                                                                colSpan={el.colspan}
                                                                rowSpan={el.rowspan}
                                                                style={{
                                                                    width: (el.size && el.size !== '' ? (el.size + '%') : 'auto')
                                                                }}
                                                            >
                                                                {
                                                                    disegnaElemento(modifica, el, idxLivello, idxSottolivello, idxElemento, errors, values, submitCount)
                                                                }
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                            )
                                        }
                                        </tbody>
                                    </table>
                                </Fragment>
                            )
                        }

                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Fragment>
    );
}